import React from "react";
import { Col, Row } from "react-bootstrap";
import Select from "react-select";

import classNames from "classnames";

import {
    selectSetting,
    selectUmpires,
} from "../../../../features/global/globalSlice";
import { useAppSelector } from "../../../../hooks/reduxHooks";
import { IUmpire } from "../../../../types/api";
import { UmpirePay } from "../../../../types/shared";

interface Props {
    umpires?: IUmpire[] | null;
    ageLevel: string;
    setPlateUmpire: React.Dispatch<React.SetStateAction<number | undefined>>;
    setFieldUmpire: React.Dispatch<React.SetStateAction<number | undefined>>;
}
const EditUmpires = ({
    umpires: gameUmpires,
    ageLevel,
    setPlateUmpire,
    setFieldUmpire,
}: Props): React.JSX.Element => {
    const umpires = useAppSelector(selectUmpires);
    const umpirePay = useAppSelector(state =>
        selectSetting(state, "wibb_umpire_pay"),
    );

    const neededUmpires: UmpirePay = umpirePay?.setting.find(
        (s: UmpirePay) => s.ageLevel === ageLevel,
    );

    return (
        <React.Fragment>
            {neededUmpires.umpires
                ?.slice()
                .sort((a, b) => {
                    if (a.title === "Umpire" || a.title == "Plate Umpire")
                        return -1;
                    if (b.title === "Umpire" || b.title == "Plate Umpire")
                        return 1;
                    return 0;
                })
                .map((u, idx) => {
                    const gameUmpire = gameUmpires?.find(gu =>
                        u.title === "Umpire" || u.title === "Plate Umpire"
                            ? gu.location === "plate"
                            : gu.location === "field",
                    );

                    const gameUmpireUser = umpires.find(
                        ump => ump.id === gameUmpire?.id,
                    );

                    return (
                        <Row
                            key={idx}
                            className={classNames(
                                idx !== 0 && {
                                    "mt-1": true,
                                },
                            )}
                        >
                            <Col xs={3}>
                                <b>
                                    {u.title === "Umpire" ||
                                    u.title === "Plate Umpire"
                                        ? "Plate"
                                        : "Field"}
                                    :
                                </b>
                            </Col>
                            <Col xs={9}>
                                <Select
                                    isSearchable={true}
                                    isClearable={true}
                                    isMulti={false}
                                    options={umpires.map(u => ({
                                        value: u.id,
                                        label: u.name,
                                    }))}
                                    defaultValue={
                                        gameUmpire
                                            ? {
                                                  value: gameUmpire?.id,
                                                  label: `${gameUmpireUser?.name}`,
                                              }
                                            : null
                                    }
                                    onChange={t => {
                                        u.title === "Umpire" ||
                                        u.title === "Plate Umpire"
                                            ? setPlateUmpire(t?.value)
                                            : setFieldUmpire(t?.value);
                                    }}
                                />
                            </Col>
                        </Row>
                    );
                })}
        </React.Fragment>
    );
};

export default EditUmpires;
